/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './cash-transaction.reducer';

export const CashTransactionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const cashTransactionEntity = useAppSelector(state => state.cashTransaction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="cashTransactionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.cashTransaction.detail.title">CashTransaction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.id">Id</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.id}</dd>
          <dt>
            <span id="inOutType">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.inOutType">In Out Type</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.inOutType}</dd>
          <dt>
            <span id="tenderedAmount">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.tenderedAmount">Tendered Amount</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.tenderedAmount}</dd>
          <dt>
            <span id="qty1">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty1">Qty 1</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty1}</dd>
          <dt>
            <span id="qty2">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty2">Qty 2</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty2}</dd>
          <dt>
            <span id="qty5">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty5">Qty 5</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty5}</dd>
          <dt>
            <span id="qty10">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty10">Qty 10</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty10}</dd>
          <dt>
            <span id="qty20">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty20">Qty 20</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty20}</dd>
          <dt>
            <span id="qty50">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty50">Qty 50</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty50}</dd>
          <dt>
            <span id="qty100">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty100">Qty 100</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty100}</dd>
          <dt>
            <span id="qty200">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty200">Qty 200</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty200}</dd>
          <dt>
            <span id="qty500">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty500">Qty 500</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty500}</dd>
          <dt>
            <span id="qty1000">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty1000">Qty 1000</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty1000}</dd>
          <dt>
            <span id="qty2000">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.qty2000">Qty 2000</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.qty2000}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.active">Active</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {cashTransactionEntity.microSec ? (
              <TextFormat value={cashTransactionEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {cashTransactionEntity.timestampEntry ? (
              <TextFormat value={cashTransactionEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {cashTransactionEntity.lastUpdated ? (
              <TextFormat value={cashTransactionEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{cashTransactionEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.cashTransaction.hospital">Hospital</Translate>
          </dt>
          <dd>{cashTransactionEntity.hospital ? cashTransactionEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/cash-transaction" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cash-transaction/${cashTransactionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CashTransactionDetail;
